import { ClipboardList } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/ui/components/Select';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { palette } from '../shared/theme';
import {
  getFormName,
  useSelectedWellnessForm,
} from '../../../hooks/analytics/useSelectedWellnessForm';

interface WellnessFormSelectProps {
  filters: WellnessFilter;
}

export function WellnessFormSelect({ filters }: WellnessFormSelectProps) {
  const { forms, selected, setFormId } = useSelectedWellnessForm(filters);

  if (forms.length === 0 || !selected) return null;

  const handleChange = (value: string) => {
    const form = forms.find(f => String(f.formid) === value);
    setFormId(!form || form.isdefault ? undefined : form.formid);
  };

  return (
    <Select value={String(selected.formid)} onValueChange={handleChange}>
      <SelectTrigger
        aria-label="Select wellness form"
        className="h-8 !w-auto max-w-[14rem] gap-2 px-2 text-xs font-medium"
        style={{
          color: palette.text,
          borderColor: palette.yellow,
          backgroundColor: `${palette.yellow}1a`,
        }}
      >
        <ClipboardList
          className="h-3.5 w-3.5 flex-shrink-0"
          style={{ color: palette.yellow }}
          aria-hidden
        />
        <span className="truncate">
          <SelectValue />
        </span>
      </SelectTrigger>
      <SelectContent
        style={{
          backgroundColor: palette.surfaceElev,
          borderColor: palette.border,
          color: palette.text,
        }}
      >
        {forms.map(form => (
          <SelectItem
            key={form.formid}
            value={String(form.formid)}
            className="text-xs focus:bg-white/10 focus:text-white"
          >
            {getFormName(form)}
            {form.isdefault ? ' (default)' : ''}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
